import type { MarketTemplateType, MarketTemplatesView } from '../types/templates';

export const getValidMarketTemplateTypes = (
  marketTemplateView: MarketTemplatesView
): MarketTemplateType[] => {
  const genericMarketTemplateTypes: MarketTemplateType[] = ['BASE'];

  if ('events' in marketTemplateView) {
    return [...genericMarketTemplateTypes, 'EVENT'];
  }

  if ('races' in marketTemplateView) {
    return [...genericMarketTemplateTypes, 'MEETING'];
  }

  return genericMarketTemplateTypes;
};
